// 사이드바 "배송관리" 메뉴 미표시 + /orders 직접 접근 차단 + 루트(/) 진입 시 /cs/tickets 로 리다이렉트 대상 클라이언트
export const ORDERS_HIDDEN_CLIENT_IDS = [
  "164880727013", // 한진택배
  "558619842636", // 한진택배
  "122741676407", // 롯데택배
  "585211958273", // 롯데택배
  "110201815933", // CJ대한통운
  "525887971183", // CJ대한통운
]
